<template>
  <custom-form
    :fields="{ service }"
    action="/api/v1/transactions/earningStructure"
    @on-error="handleError"
    @submitted="handleSubmitted"
  >
    <v-container>
      <v-alert type="error" dense outlined text tile v-if="error" v-text="error"> </v-alert>
      <v-row>
        <v-container></v-container>
        <v-col cols="16" md="2">
          <h4>Boundaries</h4>
        </v-col>
        <v-col cols="12" md="5">
          <custom-input name="min" placeholder="The minimum value/lowerbound" label="Minimum" />
        </v-col>
        <v-col cols="12" md="5">
          <custom-input name="max" placeholder="The maximum value/upperbound" label="Maximum" />
        </v-col>
      </v-row>
    </v-container>
    <v-divider></v-divider>
    <!-- commission -->
    <v-container>
      <v-row>
        <v-col cols="12" md="2">
          <h4>Commission</h4>
        </v-col>
        <v-col cols="12" md="5">
          <custom-input name="flat_commission" label="Flat" />
        </v-col>
        <v-col cols="12" md="5">
          <custom-input name="percentage_comission" label="Percentage" />
        </v-col>
      </v-row>
    </v-container>
    <v-divider></v-divider>
    <!-- Fees -->
    <v-container>
      <v-row>
        <v-col cols="12" md="2">
          <h4>Fees</h4>
        </v-col>
        <v-col cols="12" md="5">
          <custom-input name="flat_fees" label="Flat" />
        </v-col>
        <v-col cols="12" md="5">
          <custom-input name="percentage_fees" label="percentage" />
        </v-col>
      </v-row>
    </v-container>
    <v-divider></v-divider>
    <v-container>
      <v-row>
        <v-col cols="12" md="2"> </v-col>
        <v-col cols="12" md="5">
          <custom-button block raised color="primary">
            <v-icon> mdi-layers-plus</v-icon>
            Add Entry
          </custom-button>
        </v-col>
      </v-row>
    </v-container>
  </custom-form>
</template>
<script>
export default {
  props: {
    service: { required: true },
  },
  data: () => ({ error: null }),
  methods: {
    handleError(response) {
      window.Notify.warning(
        this.objectValueFromPath(response, "data.message") || "Something went wrong",
      );
      this.error = this.objectValueFromPath(response, "data.errors.error.0", null);
    },
    handleSubmitted(data) {
      this.$emit("created", data);
      // clear any errors
      this.error = null;
    },
  },
};
</script>
